import { createContext } from 'react';
import { IPreferencesContext } from './types';

const PreferencesContext = createContext<IPreferencesContext>({} as IPreferencesContext);

export default PreferencesContext;
